module.exports = __webpack_public_path__ + "img/step05_a_stand_power_right_front_leg.fcd7881e.png";